import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  Renderer2,
  PLATFORM_ID,
  Inject,
  AfterViewInit,
  Input
} from '@angular/core';

import { SvcServices } from '../../services/svc.service';
import { windowService } from '../../services/window.service';
import { isPlatformBrowser } from '@angular/common';
import { ContentService } from '../../services';
import { ChatbotService } from '../common-component/service/chatbot.service';
//import { StorageService } from '@citi-gcg-173875/citi-utils';

import { SiteCatalystPageData } from '../../models';
import { SiteCatalystService } from '../../services';

import { fromEvent, merge, interval, of } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { ChatBotInactivityTimeOutService } from '../../services/chatBot-inactivity-time-out.service';

declare var $: any;

@Component({
  selector: 'scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  host: { 'data-host': 'host' },
})
export class ScrollToTopComponent implements OnInit, AfterViewInit {

  @Input() pageData: any;
  window: any;
  branding:any
  isCovaEnabled:any;
  isChatBotAnimationEnabled: any;
  isChatBotEnabled: any;
  isIEorEdge: any;
  scPageData: SiteCatalystPageData;
  showChatBubble: boolean = false;
  covaBubbleFirstTimer:any = 0 * 1000;
  covaBubbleSecondTimer:any = 4 * 60 * 1000;
  covaChatBubbleFlag: 'timer' | 'disclosure' | null;
  @ViewChild('scrollToTop') scrollToTop;

  constructor(private _svcService: SvcServices,
    private _contentService: ContentService,
    private windowRef: windowService,
    private render: Renderer2,
    private chatbotService: ChatbotService,
    //private _storageService: StorageService,
    private scService: SiteCatalystService,
    private timeoutService: ChatBotInactivityTimeOutService,
    @Inject(PLATFORM_ID) private platformId: string) {

  }

  ngOnInit() {
    this.window = this.windowRef.nativeWindow;
    let currentLocal = this.getCurrentSiteLocale();
    this.isCovaEnabled = (currentLocal === 'en_US' || currentLocal === 'es_US') && (this.isCovaConfigEnabled());

    this._contentService.getModalContent("jCARDS_svc_cw_modals").subscribe(data => {
      if (data !== null && data !== undefined && !!data.content) {
        let modalData = data.content.CARDS;
        //let devicesEnabledForCovaChatAutoOpen =!!modalData && !!modalData["copy$$devices_enabled_for_cova_chat_auto_open"] && modalData["copy$$devices_enabled_for_cova_chat_auto_open"]["TEXT"] || null;
        //this.isDeviceEnabledForProactiveCova(devicesEnabledForCovaChatAutoOpen)
        let screenSizeEnabledForCovaChatAutoOpen =!!modalData && !!modalData["copy$$screensize_enabled_for_cova_chat_auto_open"] && modalData["copy$$screensize_enabled_for_cova_chat_auto_open"]["TEXT"] || null;
        if(this.isCovaEnabled && this.pageData &&
          this.pageData.config$$cfg_cw_app_client_settings.emergency_message_cova_partners.includes(this._svcService.getSiteId()) &&
          this.isScreenSizeEnabledForProactiveCova(screenSizeEnabledForCovaChatAutoOpen)) {
            this.scPageData = {
              pageName: this._svcService.pData.pageName
            }

           let eventObject = {
            minorInteraction: "cova_actionprompt",
            module: "cova_actionprompt",
            view: "index",
            area: "header_modules",
            linkText: "Get Help"
            };
          console.log("opening chatbot");
          this.chatbotService.showBot();
          this.scService.setSCPageData("customMinorInteraction", this.scPageData, eventObject);
        }
      }
    });
 }

  ngAfterViewInit(){
    if (isPlatformBrowser(this.platformId)) {
      this.setIEorEdge();
      this.isCovaChatBubbleEnable();
      this.setChatBotAnimationEnabled();
      this.setChatBotEnabled();
    }
  }



  isDeviceEnabledForProactiveCova(devicesEnabled:string):boolean{
    if(devicesEnabled===null) return false;
    let devicesEnabledForCovaChatAutoOpen : string[] =   !!devicesEnabled  && devicesEnabled.split(',').map(p=>p.toUpperCase());
    let currentDevice = this._svcService.getDeviceTypeForProactiveCovaChat();
    if(!!currentDevice && !!devicesEnabledForCovaChatAutoOpen && devicesEnabledForCovaChatAutoOpen.includes(currentDevice.toUpperCase())) return true;
    return false;
  }

  isScreenSizeEnabledForProactiveCova(screenSizeEnabled:string):boolean{
    if(screenSizeEnabled===null) return false;
    let screenSizeEnabledForCovaChatAutoOpen : string[] =   !!screenSizeEnabled  && screenSizeEnabled.split(',').map(p=>p.toUpperCase());
    //let screenSizeEnabledForCovaChatAutoOpen =!!modalData && !!modalData["copy$$screensize_enabled_for_cova_chat_auto_open"] && modalData["copy$$screensize_enabled_for_cova_chat_auto_open"]["TEXT"] || null;
    let checkScreenSize = this.pageData && this.pageData.config$$cfg_cw_app_client_settings
                            && this.pageData.config$$cfg_cw_app_client_settings.cova_proactive_screen_resolution || null;
    let currentScreenSize = this._svcService.getCovaScreenResolution(checkScreenSize);
    return (!!currentScreenSize && !!screenSizeEnabledForCovaChatAutoOpen
              && screenSizeEnabledForCovaChatAutoOpen.includes(currentScreenSize.toUpperCase()));
  }

  @HostListener("window:scroll") onscroll() {
    if (isPlatformBrowser(this.platformId)) {
      this.window = this.windowRef.nativeWindow;
      if (this.window.document.body.scrollTop > 300 || this.window.document.documentElement.scrollTop > 300) {
        this.render.setStyle(this.scrollToTop.nativeElement, 'display', 'block');
      } else {
        this.render.setStyle(this.scrollToTop.nativeElement, 'display', 'none');
      }
      // cova text bubble dismisses on scroll over 200px
      if (this.covaChatBubbleFlag === 'timer' && this.showChatBubble) {
        if (this.window.document.body.scrollTop > 200 || this.window.document.documentElement.scrollTop > 200) {
          this.hideCova_startTimer();
        }
      }

    }
  }

  hideCova_startTimer() {
    this.toggleCovaChatBubble(false);
    this.startIdleTimer(this.covaBubbleSecondTimer);
  }
  @HostListener("document:click", ['$event'])
  onEvent(e: Event): void {
    if (this.covaChatBubbleFlag === 'timer' && this.showChatBubble) {
      this.hideCova_startTimer();
    }
  }

  topFunction() {
    this.window.document.body.scrollTop = 0;
    this.window.document.documentElement.scrollTop = 0;
  }
  open(): void{
    if($ && !!$('.kore-chat-window')[0]){
      $('.kore-chat-window').show();
      ($('[data-module="cova_reactive"]').hide());
    }else{
      this.chatbotService.showBot();
    }
    sessionStorage.setItem("chatBotIsOpened", "YES");
  }

  openWithEnterKey($event): void{
    if ($event.keyCode === 13) {
      this.open();
    }
  }

  isCovaConfigEnabled(){
    if(this.window && 
      this.window.location && 
      this.window.location.pathname && 
      this.window.location.pathname.includes("/supported-browsers")){
      return false;
    }

    if ((this.pageData
      && this.pageData.config$$cfg_cw_app_client_settings
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_reactive
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_reactive.includes(this._svcService.getSiteId()))){
       console.log('Cova config is enabled');
       return true;
     } else {
       console.log('Cova config is disabled');
       return false;
     }

  }

  getCurrentSiteLocale(){
    return localStorage.getItem("siteLocal_ID") ? localStorage.getItem("siteLocal_ID") : "en_US";
  }

  public setChatBotAnimationEnabled(): void{

    if ((this.pageData
      && this.pageData.config$$cfg_cw_app_client_settings
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_animation
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_animation.includes(this._svcService.getSiteId()))){
        this.startChotBotTimer();
        this.isChatBotAnimationEnabled =  true;
     } else {

      this.isChatBotAnimationEnabled = false;
     }

  }

  public setChatBotEnabled(): void{

    if ((this.pageData
      && this.pageData.config$$cfg_cw_app_client_settings
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_chat_bot
      && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_cova_chat_bot.includes(this._svcService.getSiteId()))){
        this.isChatBotEnabled =  true;
     } else {

      this.isChatBotEnabled = false;
     }

  }

  public setIEorEdge(): void {
    this.isIEorEdge = this._svcService.isIEorEdge();
  }

  // toggleCovaChatBubble will control visiblity of text bubble
  toggleCovaChatBubble(flag: boolean) {
    this.showChatBubble = flag;
  }
    // COVA textbubble timer
  startIdleTimer(duration?: number) {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showChatBubble) {
        return;
      }
      let mergedStream$ = merge(
        of(1),
        // For ADA constraints, keyboard events are not included in event listerners
        fromEvent(this.window.document, 'click'),
        fromEvent(this.window.document, 'scroll'),
        fromEvent(this.window.document, 'mousemove'),
        fromEvent(this.window.document, 'wheel')
      );
      let observable$ = mergedStream$
        .pipe(
          switchMap(() => interval(duration).pipe(first()))
        )
      let subscription = observable$.subscribe(() => {
        this.toggleCovaChatBubble(true);
        subscription.unsubscribe();
      });
    }
  }

  private startChotBotTimer(): void {
    this.timeoutService.invokeNgaKeepALive = true;
    if (this.timeoutService.timeoutExpired.observers.length > 0) {
      this.timeoutService.timeoutExpired.complete();
      this.timeoutService.timeoutExpired.isStopped = false;
    }
    this.timeoutService.timeoutExpired.subscribe(() => {
      this.window = this.windowRef.nativeWindow;
      var chatBot = this.window.document.getElementById("chatBotIcon");
      if (null !== chatBot) {
        if (chatBot.style.animationName === "") {
          chatBot.style.animation = "reblink 400ms 2";
          chatBot.style.animationName = "reblink";
        } else {
          chatBot.style.animation = "blink 400ms 2";
          chatBot.style.animationName = "";
        }
        this.timeoutService.resetTimer();
      }
    });
  }

  // check if cova chat bubble enabled
  isCovaChatBubbleEnable() {
    this.setCovaChatBubbleFlags();
    if (this.covaChatBubbleFlag === 'timer') {
      this.startIdleTimer(this.covaBubbleFirstTimer);
    } else if (this.covaChatBubbleFlag === 'disclosure') {
      this.toggleCovaChatBubble(true);
    } else {
      this.toggleCovaChatBubble(false);
    }
  }

  /* Turn on/off cova chat bubble based on the cms flags
     partnerEnabledforCovaBubbleTimer - flag for cova chat bubble timer
     partnerEnabledforCovaBubbleDisclosure - flag for cova chat bubble disclosure
  */
  private setCovaChatBubbleFlags(): any {
    let isFlagAvailable = this.pageData && this.pageData.config$$cfg_cw_app_client_settings;
    if (isFlagAvailable) {
      const partnerEnabledforCovaBubbleTimer = isFlagAvailable.partner_enabled_for_cova_bubble_timer || '';
      const partnerEnabledforCovaBubbleDisclosure = isFlagAvailable.partner_enabled_for_cova_bubble_disclosure || '';
      const siteId = this._svcService.pData.siteId.toUpperCase();

      if (partnerEnabledforCovaBubbleTimer.split(",").indexOf(siteId) > -1) {
        this.covaChatBubbleFlag = 'timer';
      } else if (partnerEnabledforCovaBubbleDisclosure.split(",").indexOf(siteId) > -1) {
        this.covaChatBubbleFlag = 'disclosure';
      } else {
        this.covaChatBubbleFlag = null;
      }
    }
  }

}
